import AxiosClient from "../../../services/axios.services";

class DisciplinaryActionsServices {
  getDisciplinaryActions = (params) =>
    // AxiosClient.get("/api/app/sanciones_sancion/", {
    AxiosClient.get("/api/app/new_sanciones_sancion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveDisciplinaryActions = (data) =>
    AxiosClient.post("/api/app/sanciones_sancion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editDisciplinaryActions = (id, data) =>
    AxiosClient.put(`/api/app/sanciones_sancion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteDisciplinaryActions = (id) =>
    AxiosClient.delete(`/api/app/sanciones_sancion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  emailSend = (data) =>
    AxiosClient.post("/api/app/sanciones_accion_disciplinaria_correos/", data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new DisciplinaryActionsServices();
